var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 36,
    viewBox: "0 0 144 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9756 29.3736V35.586H29.0732V29.3736H34.5099L27.7401 23.6045C27.7401 23.6045 23.5224 28.1546 18.9756 29.3736Z",
    fill: "url(#paint0_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3153 29.5954C14.3153 29.5954 4.16225 31.5934 0 25.6027C0 25.6027 8.98941 27.1541 16.0916 23.6046C23.1906 20.0552 29.6279 14.7293 30.7361 6.85136L30.0418 6.21252C26.5445 9.70659 15.883 12.3826 15.3876 12.5032C15.3746 13.4875 14.5695 14.2828 13.5754 14.2828C12.5813 14.2828 11.7632 13.4712 11.7632 12.4706C11.7632 11.4699 12.5747 10.6583 13.5754 10.6583C14.1555 10.6583 14.6705 10.9289 14.9997 11.3493L14.9802 11.2874C24.4129 8.82004 28.888 5.15648 28.888 5.15648L28.0732 4.41008L35.8403 0.414062C35.8403 0.414062 36.5606 23.6601 14.3153 29.5954Z",
    fill: "url(#paint1_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6632 21.0523C44.6632 21.0523 46.5471 25.961 40.6671 28.9857C40.6671 28.9857 38.6757 30.7066 35.8432 28.9857L33.9528 27.2647L35.5629 25.9349C35.5629 25.9349 39.8914 27.3495 39.836 22.607L42.776 22.5516L42.6097 21.2739L39.9468 21.0523C39.9468 21.0523 38.4247 17.7668 34.9534 17.2812L33.8974 18.7773L32.1797 18.1677C32.1797 18.1677 34.0701 16.0035 35.8432 11.7304C35.8432 11.7304 37.7272 11.4534 37.5055 13.1744C37.5055 13.1744 36.5049 14.3771 36.7885 15.1854C36.9188 15.8503 37.5055 16.3523 38.2096 16.3523C38.8191 16.3523 39.3406 15.9742 39.5524 15.4396C39.6111 15.3582 39.6665 15.2669 39.7252 15.1658H41.6091V14.2826L39.2786 13.8947C39.2786 13.8947 39.2591 10.8732 35.8432 10.4006L36.896 7.18359C36.896 7.18359 41.9448 7.3759 42.4435 13.1744C42.4435 13.1744 47.0197 15.4755 44.6632 21.0523Z",
    fill: "url(#paint2_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0665 26.3782L29.1846 22.3822L31.4042 19.8301H34.1226C34.1226 19.8301 35.0645 21.4402 37.1179 19.8301C37.1179 19.8301 39.4745 21.2186 37.9491 24.4356L34.8983 24.6572L33.0665 26.3782Z",
    fill: "url(#paint3_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1906 13.8949L21.3034 12.3402L26.1306 10.9517V15.1628L24.6312 14.8369C24.6312 14.8369 16.1177 27.8744 0 21.4404C0 21.4404 15.0062 25.0811 23.1906 13.8949Z",
    fill: "url(#paint4_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2513 14.6315C20.7949 15.2247 14.5174 17.8811 11.975 17.6106C11.9424 18.5851 11.1439 19.3609 10.1661 19.3609C9.18825 19.3609 8.35059 18.5493 8.35059 17.5454C8.35059 16.5415 9.16217 15.7332 10.1661 15.7332C10.7625 15.7332 11.2906 16.02 11.6198 16.4665C11.6198 16.4665 17.3204 16.2938 20.8341 13.8818C20.8341 13.8818 21.7271 14.0057 21.2513 14.6315Z",
    fill: "url(#paint5_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.835 5.70996H67.7467V9.62775H57.1439V13.7965H66.4886V17.7143H57.1439V25.2957H52.835V5.70996Z",
    fill: "#16273A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9346 4.87305H75.1881V25.2964H70.9346V4.87305Z",
    fill: "#16273A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.46 17.8812V17.8258C78.46 13.5462 81.5108 10.0195 85.8751 10.0195C90.8815 10.0195 93.1761 13.908 93.1761 18.1615C93.1761 18.4972 93.1468 18.8623 93.1207 19.2795H82.6841C83.1046 21.209 84.4475 22.2162 86.3477 22.2162C87.7753 22.2162 88.7825 21.7696 89.9852 20.6777L92.4199 22.8322C90.9923 24.5955 89.0074 25.6288 86.2923 25.6288C81.7878 25.6288 78.46 22.4672 78.46 17.8779V17.8812ZM89.0334 16.6231C88.7825 14.7196 87.6612 13.4321 85.8718 13.4321C84.0824 13.4321 82.9612 14.6902 82.6255 16.6231H89.0334Z",
    fill: "#16273A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6074 17.8812V17.8258C95.6074 13.5462 98.6582 10.0195 103.023 10.0195C108.029 10.0195 110.324 13.908 110.324 18.1615C110.324 18.4972 110.294 18.8623 110.268 19.2795H99.8316C100.252 21.209 101.595 22.2162 103.495 22.2162C104.923 22.2162 105.93 21.7696 107.133 20.6777L109.567 22.8322C108.14 24.5955 106.155 25.6288 103.44 25.6288C98.9353 25.6288 95.6074 22.4672 95.6074 17.8779V17.8812ZM106.181 16.6231C105.93 14.7196 104.809 13.4321 103.019 13.4321C101.23 13.4321 100.109 14.6902 99.7729 16.6231H106.181Z",
    fill: "#16273A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.128 5.70996H118.437V25.2924H114.128V5.70996Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.815 25.8828L138.661 23.9532C136.982 25.0451 135.053 25.6318 132.843 25.6318C126.8 25.6318 122.465 21.1273 122.465 15.5603V15.5049C122.465 9.93782 126.859 5.37793 132.901 5.37793C138.944 5.37793 143.279 9.88241 143.279 15.4495V15.5049C143.279 17.6039 142.637 19.4781 141.545 21.1273L143.56 22.8352L140.818 25.886L140.815 25.8828ZM135.444 21.1273L132.282 18.4122L135.023 15.3354L138.24 18.246C138.605 17.4344 138.772 16.5381 138.772 15.5603V15.5049C138.772 12.1477 136.311 9.35113 132.839 9.35113C129.368 9.35113 126.966 12.0923 126.966 15.4495V15.5049C126.966 18.862 129.427 21.6586 132.898 21.6586C133.876 21.6586 134.688 21.463 135.444 21.1273Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.332 4.72286V1.60036L116.533 0L119.222 1.60036V4.72286L116.279 3.26917L113.332 4.72286Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9492 33.8326V27.291H57.0789V28.1222H53.9759V30.1397H56.5443V30.9611H53.9759V33.8294H52.9492V33.8326Z",
    fill: "url(#paint6_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9199 33.8324V27.105H59.9466V33.8324H58.9199Z",
    fill: "url(#paint7_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2009 33.9434C63.7414 33.9434 63.3339 33.8424 62.9819 33.6403C62.6299 33.4382 62.3529 33.1546 62.1508 32.7961C61.9487 32.4343 61.8477 32.0139 61.8477 31.5347C61.8477 31.0556 61.9487 30.6286 62.1475 30.2603C62.3463 29.8887 62.6234 29.6019 62.9787 29.3966C63.3339 29.1912 63.7446 29.0869 64.214 29.0869C64.6833 29.0869 65.0647 29.188 65.4069 29.3868C65.7491 29.5856 66.0099 29.8529 66.1957 30.1918C66.3815 30.5276 66.476 30.9057 66.476 31.3229V31.5249C66.476 31.5966 66.4695 31.6749 66.4564 31.7629H62.6071V31.0719H65.4493C65.4297 30.7231 65.3059 30.4461 65.0712 30.2407C64.8365 30.0354 64.553 29.9311 64.2172 29.9311C63.9728 29.9311 63.7511 29.9865 63.5458 30.0941C63.3405 30.2016 63.1742 30.3613 63.0504 30.5699C62.9265 30.7785 62.8646 31.0458 62.8646 31.3685V31.6292C62.8646 31.9421 62.9265 32.2062 63.0504 32.4278C63.1742 32.6494 63.3372 32.8157 63.5393 32.9265C63.7414 33.0373 63.963 33.096 64.2075 33.096C64.4812 33.096 64.7127 33.034 64.8984 32.9102C65.0842 32.7863 65.2211 32.6168 65.3091 32.405H66.3456C66.2641 32.6983 66.1272 32.9623 65.9284 33.1937C65.7296 33.4252 65.4884 33.611 65.1983 33.7446C64.9082 33.8782 64.5758 33.9467 64.2042 33.9467L64.2009 33.9434Z",
    fill: "url(#paint8_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.573 33.9434C70.1134 33.9434 69.706 33.8424 69.354 33.6403C69.002 33.4382 68.7249 33.1546 68.5228 32.7961C68.3208 32.4343 68.2197 32.0139 68.2197 31.5347C68.2197 31.0556 68.3208 30.6286 68.5196 30.2603C68.7184 29.8887 68.9955 29.6019 69.3507 29.3966C69.706 29.1912 70.1167 29.0869 70.586 29.0869C71.0554 29.0869 71.4367 29.188 71.779 29.3868C72.1212 29.5856 72.382 29.8529 72.5678 30.1918C72.7535 30.5276 72.8481 30.9057 72.8481 31.3229V31.5249C72.8481 31.5966 72.8415 31.6749 72.8285 31.7629H68.9792V31.0719H71.8214C71.8018 30.7231 71.6779 30.4461 71.4433 30.2407C71.2086 30.0354 70.925 29.9311 70.5893 29.9311C70.3449 29.9311 70.1232 29.9865 69.9179 30.0941C69.7125 30.2016 69.5463 30.3613 69.4224 30.5699C69.2986 30.7785 69.2367 31.0458 69.2367 31.3685V31.6292C69.2367 31.9421 69.2986 32.2062 69.4224 32.4278C69.5463 32.6494 69.7093 32.8157 69.9114 32.9265C70.1134 33.0373 70.3351 33.096 70.5795 33.096C70.8533 33.096 71.0847 33.034 71.2705 32.9102C71.4563 32.7863 71.5932 32.6168 71.6812 32.405H72.7177C72.6362 32.6983 72.4993 32.9623 72.3005 33.1937C72.1017 33.4252 71.8605 33.611 71.5704 33.7446C71.2803 33.8782 70.9478 33.9467 70.5763 33.9467L70.573 33.9434Z",
    fill: "url(#paint9_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.423 33.8325C76.1362 33.8325 75.8917 33.7999 75.6929 33.7282C75.494 33.6598 75.3441 33.5294 75.2431 33.3371C75.142 33.1448 75.0931 32.8645 75.0931 32.4962V30.0679H74.2979V29.1976H75.0931V28.0112H76.1199V29.1976H77.3617V30.0679H76.1199V32.356C76.1199 32.5353 76.1361 32.6689 76.172 32.7536C76.2079 32.8384 76.2698 32.8938 76.3578 32.9166C76.4491 32.9427 76.5794 32.9525 76.7554 32.9525H77.3161V33.8292H76.4197L76.423 33.8325Z",
    fill: "url(#paint10_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3301 33.8326V27.291H84.3568V33.8326H83.3301Z",
    fill: "url(#paint11_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5732 33.8324V29.1976H87.6V29.9342C87.7564 29.6734 87.9683 29.4648 88.2355 29.3117C88.5028 29.1585 88.8092 29.0835 89.1514 29.0835C89.7186 29.0835 90.1618 29.2595 90.478 29.6115C90.7942 29.9635 90.9539 30.485 90.9539 31.176V33.8292H89.9272V31.2771C89.9272 30.8403 89.8392 30.5111 89.6599 30.2895C89.4806 30.0678 89.2134 29.957 88.8516 29.957C88.4898 29.957 88.1899 30.0841 87.9552 30.3416C87.7173 30.5959 87.6 30.9609 87.6 31.4335V33.8259H86.5732V33.8324Z",
    fill: "url(#paint12_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6466 33.8325C94.3598 33.8325 94.1153 33.7999 93.9165 33.7282C93.7177 33.6598 93.5678 33.5294 93.4667 33.3371C93.3657 33.1448 93.3168 32.8645 93.3168 32.4962V30.0679H92.5215V29.1976H93.3168V28.0112H94.3435V29.1976H95.5853V30.0679H94.3435V32.356C94.3435 32.5353 94.3598 32.6689 94.3956 32.7536C94.4315 32.8384 94.4934 32.8938 94.5814 32.9166C94.6727 32.9427 94.8031 32.9525 94.9791 32.9525H95.5397V33.8292H94.6434L94.6466 33.8325Z",
    fill: "url(#paint13_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3562 33.9434C98.8966 33.9434 98.4892 33.8424 98.1372 33.6403C97.7852 33.4382 97.5081 33.1546 97.3061 32.7961C97.104 32.4343 97.0029 32.0139 97.0029 31.5347C97.0029 31.0556 97.104 30.6286 97.3028 30.2603C97.5016 29.8887 97.7787 29.6019 98.1339 29.3966C98.4892 29.1912 98.8999 29.0869 99.3693 29.0869C99.8386 29.0869 100.22 29.188 100.562 29.3868C100.904 29.5856 101.165 29.8529 101.351 30.1918C101.537 30.5276 101.631 30.9057 101.631 31.3229V31.5249C101.631 31.5966 101.625 31.6749 101.612 31.7629H97.7624V31.0719H100.605C100.585 30.7231 100.461 30.4461 100.226 30.2407C99.9918 30.0354 99.7082 29.9311 99.3725 29.9311C99.1281 29.9311 98.9064 29.9865 98.7011 30.0941C98.4957 30.2016 98.3295 30.3613 98.2056 30.5699C98.0818 30.7785 98.0199 31.0458 98.0199 31.3685V31.6292C98.0199 31.9421 98.0818 32.2062 98.2056 32.4278C98.3295 32.6494 98.4925 32.8157 98.6946 32.9265C98.8966 33.0373 99.1183 33.096 99.3627 33.096C99.6365 33.096 99.8679 33.034 100.054 32.9102C100.24 32.7863 100.376 32.6168 100.464 32.405H101.501C101.419 32.6983 101.283 32.9623 101.084 33.1937C100.885 33.4252 100.644 33.611 100.354 33.7446C100.064 33.8782 99.731 33.9467 99.3595 33.9467L99.3562 33.9434Z",
    fill: "url(#paint14_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.597 33.8324V27.105H104.623V33.8324H103.597Z",
    fill: "url(#paint15_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.749 33.8324V27.105H107.776V33.8324H106.749Z",
    fill: "url(#paint16_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.868 28.3766V27.2651H110.96V28.3766H109.868ZM109.898 33.8328V29.198H110.924V33.8328H109.898Z",
    fill: "url(#paint17_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.457 36.0001C115.053 36.0001 114.675 35.9316 114.326 35.798C113.978 35.6644 113.684 35.4623 113.446 35.1918C113.208 34.9212 113.062 34.579 113.006 34.1683H114.027C114.102 34.4551 114.268 34.6833 114.522 34.856C114.776 35.0288 115.083 35.1135 115.438 35.1135C115.699 35.1135 115.94 35.0581 116.158 34.944C116.377 34.83 116.549 34.6637 116.676 34.4388C116.804 34.2139 116.869 33.9304 116.869 33.5881V32.9721C116.774 33.1351 116.65 33.285 116.494 33.4219C116.337 33.5588 116.152 33.6696 115.933 33.7576C115.715 33.8456 115.467 33.888 115.187 33.888C114.75 33.888 114.356 33.7837 114.004 33.5718C113.652 33.36 113.371 33.0732 113.166 32.7081C112.961 32.343 112.856 31.9356 112.856 31.4793C112.856 31.023 112.957 30.6156 113.166 30.2538C113.371 29.892 113.652 29.6084 114.004 29.3998C114.356 29.1912 114.753 29.0869 115.197 29.0869C115.578 29.0869 115.911 29.1684 116.201 29.3314C116.491 29.4943 116.712 29.6932 116.869 29.9278V29.1977H117.895V33.5523C117.895 34.077 117.788 34.5203 117.57 34.8854C117.351 35.2504 117.058 35.5275 116.693 35.7165C116.324 35.9056 115.914 36.0001 115.461 36.0001H115.457ZM115.382 32.9917C115.669 32.9917 115.92 32.9265 116.139 32.7961C116.357 32.6657 116.53 32.4865 116.657 32.2583C116.784 32.0301 116.849 31.7727 116.849 31.4858C116.849 31.199 116.784 30.9252 116.657 30.7003C116.53 30.4754 116.357 30.2994 116.139 30.1723C115.92 30.0452 115.669 29.98 115.382 29.98C115.096 29.98 114.841 30.0452 114.62 30.1723C114.398 30.2994 114.225 30.4754 114.095 30.7003C113.965 30.9252 113.903 31.1827 113.903 31.4761C113.903 31.7694 113.968 32.0301 114.095 32.255C114.222 32.4799 114.398 32.6625 114.62 32.7928C114.841 32.9232 115.096 32.9884 115.382 32.9884V32.9917Z",
    fill: "url(#paint18_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.139 33.9434C121.68 33.9434 121.272 33.8424 120.92 33.6403C120.568 33.4382 120.291 33.1546 120.089 32.7961C119.887 32.4343 119.786 32.0139 119.786 31.5347C119.786 31.0556 119.887 30.6286 120.086 30.2603C120.285 29.8887 120.562 29.6019 120.917 29.3966C121.272 29.1912 121.683 29.0869 122.152 29.0869C122.622 29.0869 123.003 29.188 123.345 29.3868C123.688 29.5856 123.948 29.8529 124.134 30.1918C124.32 30.5276 124.414 30.9057 124.414 31.3229V31.5249C124.414 31.5966 124.408 31.6749 124.395 31.7629H120.546V31.0719H123.388C123.368 30.7231 123.244 30.4461 123.01 30.2407C122.775 30.0354 122.491 29.9311 122.156 29.9311C121.911 29.9311 121.69 29.9865 121.484 30.0941C121.279 30.2016 121.113 30.3613 120.989 30.5699C120.865 30.7785 120.803 31.0458 120.803 31.3685V31.6292C120.803 31.9421 120.865 32.2062 120.989 32.4278C121.113 32.6494 121.276 32.8157 121.478 32.9265C121.68 33.0373 121.901 33.096 122.146 33.096C122.42 33.096 122.651 33.034 122.837 32.9102C123.023 32.7863 123.16 32.6168 123.248 32.405H124.284C124.203 32.6983 124.066 32.9623 123.867 33.1937C123.668 33.4252 123.427 33.611 123.137 33.7446C122.847 33.8782 122.514 33.9467 122.143 33.9467L122.139 33.9434Z",
    fill: "url(#paint19_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.37 33.8324V29.1976H127.397V29.9342C127.553 29.6734 127.765 29.4648 128.032 29.3117C128.3 29.1585 128.606 29.0835 128.948 29.0835C129.515 29.0835 129.959 29.2595 130.275 29.6115C130.591 29.9635 130.751 30.485 130.751 31.176V33.8292H129.724V31.2771C129.724 30.8403 129.636 30.5111 129.457 30.2895C129.277 30.0678 129.01 29.957 128.648 29.957C128.287 29.957 127.987 30.0841 127.752 30.3416C127.514 30.5959 127.397 30.9609 127.397 31.4335V33.8259H126.37V33.8324Z",
    fill: "url(#paint20_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.014 33.9434C134.552 33.9434 134.144 33.8391 133.786 33.6338C133.427 33.4284 133.147 33.1416 132.941 32.7798C132.736 32.418 132.632 31.9943 132.632 31.5152C132.632 31.036 132.736 30.6123 132.941 30.2505C133.147 29.8887 133.43 29.6019 133.786 29.3966C134.144 29.1912 134.555 29.0869 135.014 29.0869C135.588 29.0869 136.07 29.2368 136.462 29.5367C136.853 29.8366 137.104 30.244 137.208 30.7622H136.142C136.08 30.5145 135.947 30.319 135.741 30.1788C135.536 30.0387 135.288 29.967 135.005 29.967C134.773 29.967 134.558 30.0289 134.356 30.1495C134.154 30.2701 133.991 30.4461 133.87 30.6742C133.75 30.9024 133.688 31.1827 133.688 31.5184C133.688 31.8541 133.75 32.1312 133.87 32.3659C133.991 32.6005 134.154 32.7765 134.356 32.8939C134.558 33.0112 134.777 33.0699 135.005 33.0699C135.292 33.0699 135.536 33.0014 135.741 32.8646C135.947 32.7277 136.08 32.5321 136.142 32.2746H137.208C137.107 32.7733 136.859 33.1775 136.465 33.4838C136.07 33.7935 135.585 33.9467 135.011 33.9467L135.014 33.9434Z",
    fill: "url(#paint21_linear_29_991)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.285 33.9434C140.825 33.9434 140.418 33.8424 140.066 33.6403C139.714 33.4382 139.437 33.1546 139.235 32.7961C139.033 32.4343 138.932 32.0139 138.932 31.5347C138.932 31.0556 139.033 30.6286 139.232 30.2603C139.43 29.8887 139.707 29.6019 140.063 29.3966C140.418 29.1912 140.829 29.0869 141.298 29.0869C141.767 29.0869 142.149 29.188 142.491 29.3868C142.833 29.5856 143.094 29.8529 143.28 30.1918C143.465 30.5276 143.56 30.9057 143.56 31.3229V31.5249C143.56 31.5966 143.553 31.6749 143.54 31.7629H139.691V31.0719H142.533C142.514 30.7231 142.39 30.4461 142.155 30.2407C141.921 30.0354 141.637 29.9311 141.301 29.9311C141.057 29.9311 140.835 29.9865 140.63 30.0941C140.424 30.2016 140.258 30.3613 140.134 30.5699C140.011 30.7785 139.949 31.0458 139.949 31.3685V31.6292C139.949 31.9421 140.011 32.2062 140.134 32.4278C140.258 32.6494 140.421 32.8157 140.623 32.9265C140.825 33.0373 141.047 33.096 141.291 33.096C141.565 33.096 141.797 33.034 141.982 32.9102C142.168 32.7863 142.305 32.6168 142.393 32.405H143.43C143.348 32.6983 143.211 32.9623 143.012 33.1937C142.814 33.4252 142.572 33.611 142.282 33.7446C141.992 33.8782 141.66 33.9467 141.288 33.9467L141.285 33.9434Z",
    fill: "url(#paint22_linear_29_991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_991",
    x1: 16.9084,
    y1: 31.9829,
    x2: 25.9668,
    y2: 20.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_991",
    x1: -4.76969,
    y1: 21.0436,
    x2: 17.8101,
    y2: -5.43299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_29_991",
    x1: 30.4287,
    y1: 22.9642,
    x2: 45.3802,
    y2: 14.5507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_29_991",
    x1: 27.9499,
    y1: 24.409,
    x2: 32.7865,
    y2: 17.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_29_991",
    x1: -3.47724,
    y1: 19.5338,
    x2: 4.00861,
    y2: 4.15132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_29_991",
    x1: 6.61529,
    y1: 17.7132,
    x2: 9.72383,
    y2: 10.5728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_29_991",
    x1: 52.3997,
    y1: 31.8654,
    x2: 56.9056,
    y2: 29.1201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_29_991",
    x1: 58.7833,
    y1: 31.8093,
    x2: 60.2868,
    y2: 31.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_29_991",
    x1: 61.2318,
    y1: 32.4852,
    x2: 64.9852,
    y2: 29.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_29_991",
    x1: 67.6038,
    y1: 32.4852,
    x2: 71.3573,
    y2: 29.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_29_991",
    x1: 73.8901,
    y1: 32.0819,
    x2: 77.5339,
    y2: 30.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_29_991",
    x1: 83.1935,
    y1: 31.8654,
    x2: 84.6951,
    y2: 31.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_29_991",
    x1: 85.9903,
    y1: 32.4043,
    x2: 89.6465,
    y2: 29.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_29_991",
    x1: 92.1138,
    y1: 32.0819,
    x2: 95.7575,
    y2: 30.2311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_29_991",
    x1: 96.387,
    y1: 32.4852,
    x2: 100.141,
    y2: 29.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_29_991",
    x1: 103.46,
    y1: 31.8093,
    x2: 104.964,
    y2: 31.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_29_991",
    x1: 106.612,
    y1: 31.8093,
    x2: 108.116,
    y2: 31.5878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_29_991",
    x1: 109.723,
    y1: 31.8578,
    x2: 111.315,
    y2: 31.6022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_29_991",
    x1: 112.186,
    y1: 33.9211,
    x2: 117.229,
    y2: 30.3733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_29_991",
    x1: 119.17,
    y1: 32.4852,
    x2: 122.924,
    y2: 29.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_29_991",
    x1: 125.787,
    y1: 32.4043,
    x2: 129.443,
    y2: 29.1493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_29_991",
    x1: 132.023,
    y1: 32.4852,
    x2: 135.773,
    y2: 29.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_29_991",
    x1: 138.316,
    y1: 32.4852,
    x2: 142.069,
    y2: 29.0352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F46E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F197F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.557,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06e3b669d789096fbf097f997d3d0c0c.svg";
export { ForwardRef as ReactComponent };